export const GUID_EMPTY='00000000-0000-0000-0000-000000000000';
export const ALL_FILE_TYPES = 'image/png,image/jpeg,image/gif,image/bmp,application/pdf,application/msword,application/x-xls,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-powerpoint,,application/x-zip-compressed';
export const IMAGE_FILE_TYPES='image/png,image/jpeg';


export enum DisplayModeEnum {
  Edit, View,
  Create,
}

export enum TargetModeEnum {
  Device, DeviceModel
}
